<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {
}
</script>
